'use strict';

import React from 'react';

export default function IconSaveSearch (props) {

  const color = props.color || '#FF7F29';
  const height = props.height || '16';
  const width = props.width || '18';

  return (
    <svg width={width} height={height} viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 3.90955C18 1.50042 16.7105 0 14.7 0C13.7834 0 13.0742 0.341052 12.6 1.0137C12.1258 0.341052 11.4166 0 10.5 0C8.48951 0 7.2 1.50042 7.2 3.90955C7.2 5.79522 8.95703 7.92781 12.437 10.3732C12.5362 10.4429 12.6638 10.4429 12.763 10.3732C16.243 7.92781 18 5.79522 18 3.90955Z" fill={color}/>
      <path d="M6.42783 0.648893C6.72417 0.648893 7.01583 0.669634 7.30152 0.709789C7.09607 1.00364 6.92618 1.33817 6.79527 1.7098C6.67384 1.70138 6.55132 1.69711 6.42783 1.69711C3.43756 1.69711 1.01348 4.20427 1.01348 7.29701C1.01348 10.3898 3.43756 12.8969 6.42783 12.8969C8.41739 12.8969 10.1563 11.787 11.0974 10.1332C11.3654 10.342 11.645 10.5528 11.9362 10.7657C11.7396 11.1045 11.5144 11.4229 11.2635 11.7169L14.3449 14.8978C14.5018 15.0601 14.5018 15.2572 14.2283 15.533C13.9548 15.8088 13.6782 15.7972 13.5213 15.6349L10.4694 12.4912C9.33626 13.5258 8.05825 13.9451 6.42783 13.9451C2.87784 13.9451 0 10.9687 0 7.29701C0 3.62536 2.87784 0.648893 6.42783 0.648893Z" fill={color}/>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/ui/Icons/IconSaveSearch.jsx